export const DEFAULT_ITEMS_ON_PAGE = 10;
export const DEFAULT_PAGE = 1;
